<script>
import {ref} from "vue";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import $ from "jquery";

export default {
  name: "MyCars",
  components: {LoadingPage},
  setup() {
    let loading = ref(false)
    let dialog = ref({
      action: false,
      type: 'add',
    })

    let my_cars = ref([])
    let details_add_car = ref({
      name: '',
      ir: '',
      num1: '',
      alphabet: null,
      num2: '',
    })

    function get_cars() {
      loading.value = true
      FreeWorld.Heisenberg({action: 'show'}, 'my_cars', true).then((res) => {
        loading.value = false
        my_cars.value = res.data
      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, get_cars)
      })
    }

    get_cars()

    function open_dialog(type, item) {
      let div_dialog = $('#dialog')

      switch (type) {
        case 'show':
          if (dialog.value.action) {
            div_dialog.removeClass('animate__fadeIn').addClass('animate__fadeOut')
            setTimeout(() => {
              dialog.value.action = false
              details_add_car.value = {
                name: '',
                ir: '',
                num1: '',
                alphabet: null,
                num2: '',
              }
            }, 700)
          } else {
            div_dialog.removeClass('animate__fadeOut').addClass('animate__fadeIn')
            dialog.value.action = true
          }
          break;

        case 'edit':
          dialog.value.type = 'edit'
          details_add_car.value.name = item.name
          details_add_car.value.num2 = item.num2
          details_add_car.value.num1 = item.num1
          details_add_car.value.ir = item.ir
          details_add_car.value.alphabet = item.alphabet
          details_add_car.value.car_id = item.id
          open_dialog('show')
          break;
      }
    }

    function add_car() {
      if (details_add_car.value.name.length === 0) {
        Swals.Warning('لطفا نام خودرو را وارد کنید!');
        return false
      }
      if (details_add_car.value.num2.toString().length !== 3) {
        Swals.Warning('لطفا پلاک خودرو را به صورت صحیح وارد کنید!');
        return false
      }
      if (details_add_car.value.num1.toString().length !== 2) {
        Swals.Warning('لطفا پلاک خودرو را به صورت صحیح وارد کنید!');
        return false
      }
      if (details_add_car.value.ir.toString().length !== 2) {
        Swals.Warning('لطفا پلاک خودرو را به صورت صحیح وارد کنید!');
        return false
      }
      if (details_add_car.value.alphabet === null) {
        Swals.Warning('لطفا پلاک خودرو را به صورت صحیح وارد کنید!');
        return false
      }

      dialog.value.type === 'edit' ? details_add_car.value.action = 'update' : details_add_car.value.action = 'add'

      loading.value = true
      FreeWorld.Heisenberg(details_add_car.value, 'my_cars', true).then((res) => {
        if (res.data.status === 'ok') {
          Swals.Done('خودروی شما با موفقیت ثبت شد')
          get_cars()
        } else {
          Swals.Fault('متاسفانه خودروی شما ثبت نشد!')
        }
        open_dialog('show')
      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, add_car)
      })
    }

    function delete_car(item) {

      Swals.Question('آیا از حذف این خودرو اطمینان دارید؟', 'حذف').then((res) => {
        if (res.isConfirmed) {

          loading.value = true
          FreeWorld.Heisenberg({car_id: item.id , action: 'delete'}, 'my_cars', true).then((res) => {
            loading.value = false
            if (res.data.status === 'ok') {
              Swals.Done('خودروی شما با موفقیت حذف شد')
              get_cars()
            } else {
              Swals.Fault('متاسفانه خودروی شما حذف نشد!')
            }
          }).catch((res) => {
            loading.value = false
            Swals.Catch(res, () => {
              delete_car(item)
            })
          })

        }
      })

    }

    return {
      loading,
      dialog,
      open_dialog,
      my_cars,
      add_car,
      details_add_car,
      delete_car,
    }
  }
}
</script>

<template>
  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass':''" class="bg-color-liner">
    <div v-if="dialog.action" @click="open_dialog('show')" class="bg_dialog"></div>
    <div v-if="dialog.action" id="dialog" class="animate__animated animate__fadeIn dialog px-3">
      <div class="rounded-4 bg-white p-3">
        <div class="position-relative">
          <p v-if="dialog.type === 'add'" class="font-4 text-color font-bold text-center">ثبت خودرو</p>
          <p v-else class="font-4 text-color font-bold text-center">ویرایش خودرو</p>
          <img @click="open_dialog('show')" class="icon-size-3 position-absolute top-0 start-0"
               src="../assets/img/icon-closeBgColor.svg" alt="">
        </div>

        <hr>

        <div class="">
          <p class="font-4 text-color mb-2">نام خودرو :</p>

          <input v-model="details_add_car.name" class="p-3 w-100 bg-custom rounded-pill shadow-custom mb-4 text-center">
        </div>

        <div class="">
          <p class="font-4 text-color mb-2">پلاک خودرو :</p>

          <div class="position-relative mb-5">
            <img src="../assets/img/pelak.jpg" alt="" class="w-100">

            <div class="d-flex justify-content-evenly position-absolute align-items-end center-y">
              <input v-model="details_add_car.ir" style="height: 3.3rem" class="w-15 font-2 bg-white" type="tel"
                     maxlength="2" placeholder="**" onkeydown="return event.key != ' '">

              <div class="d-flex w-70">
                <input v-model="details_add_car.num2" style="height: 4rem" class="w-25 font-2" maxlength="3" type="tel"
                       placeholder="***" onkeydown="return event.key != ' '">

                <select v-model="details_add_car.alphabet" style="height: 4rem" id="select-pelak" aria-label="Large select example"
                        class="w-25 text-center bg-white border-0 mx-4 font-3">
                  <option>الف</option>
                  <option>ب</option>
                  <option>پ</option>
                  <option>ت</option>
                  <option>ث</option>
                  <option>ج</option>
                  <option>چ</option>
                  <option>ح</option>
                  <option>خ</option>
                  <option>د</option>
                  <option>ذ</option>
                  <option>ر</option>
                  <option>ز</option>
                  <option>ژ</option>
                  <option>س</option>
                  <option>ش</option>
                  <option>ص</option>
                  <option>ض</option>
                  <option>ط</option>
                  <option>ظ</option>
                  <option>ع</option>
                  <option>غ</option>
                  <option>ف</option>
                  <option>ق</option>
                  <option>ک</option>
                  <option>گ</option>
                  <option>ل</option>
                  <option>م</option>
                  <option>ن</option>
                  <option>و</option>
                  <option>ه</option>
                  <option>ی</option>
                </select>

                <input v-model="details_add_car.num1" style="height: 4rem" class="w-25 font-2" type="tel" maxlength="2"
                       placeholder="**" onkeydown="return event.key != ' '">
              </div>

            </div>
          </div>
        </div>

        <div class="d-flex justify-content-center">
          <p @click="add_car" class="font-4 font-bold text-center rounded-pill bg-color-liner text-white p-3 w-35">
            ثبت</p>
        </div>
      </div>
    </div>

    <div style="height: 5rem" class="d-flex align-items-center p-4">
      <img onclick="window.history.back()" class="icon-size-1 rounded-pill ms-3" src="../assets/img/icon-back.svg" alt="">
      <p class="text-white font-bold font-4">خودرو های من</p>
    </div>

    <div id="chile-main" class="bg-main rounded-top-5 p-3 pt-4">
      <div v-if="my_cars.length === 0"
           class="animate__animated animate__fadeIn w-100 h-100 d-flex justify-content-center">
        <div class="d-flex flex-column justify-content-center align-items-center">
          <img style="width: 12rem" src="../assets/img/icon-delivery.svg" alt="" class="mb-4">
          <p class="font-4 text-center">در حال حاضر خودرویی وجود ندارد</p>
        </div>
      </div>


      <div v-else v-for="item in my_cars" :key="item.id"
           class="animate__animated animate__fadeIn d-flex justify-content-between p-3 shadow-custom rounded-4 mb-3">
        <div class="w-50">
          <p class="font-5 font-bold text-color mb-4">{{ item.name }}</p>

          <div class="d-flex align-items-center justify-content-between">
            <div @click="open_dialog('edit' , item)"
                 class="d-flex align-items-center justify-content-center w-45 py-2 bg-yellow rounded-pill">
              <img class="icon-size-0-5" src="../assets/img/icon-editingPen.svg" alt="">

              <p class="font-6 font-bold me-2 ">ویرایش</p>
            </div>

            <div @click="delete_car(item)" class="d-flex align-items-center justify-content-center w-45 py-2 bg-red rounded-pill">
              <img class="icon-size-0-5" src="../assets/img/icon-binColor.svg" alt="">

              <p class="font-6 font-bold me-2">حذف</p>
            </div>
          </div>
        </div>

        <div class="w-45">
          <div class="position-relative mb-5">
            <img src="../assets/img/pelak.jpg" alt="" class="w-100">

            <div class="d-flex justify-content-evenly position-absolute align-items-end center-y w-100">
              <p style="height: 1.8rem" class="w-20 font-4 d-flex align-items-center">{{ item.ir }}</p>

              <div class="d-flex w-70">
                <p style="height: 2.2rem" class="w-30 font-4 d-flex align-items-center justify-content-center">
                  {{ item.num2 }}</p>
                <p style="height: 2.2rem"
                   class="w-20 text-center mx-2 font-4 d-flex align-items-center justify-content-center">
                  {{ item.alphabet }}</p>
                <p style="height: 2.2rem" class="w-25 font-4 d-flex align-items-center justify-content-center">
                  {{ item.num1 }}</p>
              </div>

            </div>
          </div>
        </div>
      </div>


      <div @click="dialog.type = 'show' ; open_dialog('show')"
           class="position-fixed bottom-5 d-flex flex-column align-items-center me-3">
        <img class="icon-size-6 mb-3" src="../assets/img/icon-add.svg" alt="">
        <p class="font-5 text-color font-bold">ثبت خودرو جدید</p>
      </div>
    </div>
  </div>

</template>

<style scoped>

</style>